import React from 'react'
import { useAuth } from '@/lib/AuthContext'
import { useCommunity } from '@/lib/CommunityContext'
import { useRealtime } from '@/lib/realtime/RealtimeProvider'
import { clearChannelUnread, refreshChannelUnread } from './channelUnread'

const TOPICS = ['channel.messages', 'channel.thread', 'channel.changed']

/**
 * F-138: keeps the menu's unread channels fresh. Listens to the rooms of the
 * channel spaces the menu shows (the F-110 `space:<id>` rooms) and refetches
 * `GET /channels/unread` once per burst of notices, after a reconnect and on
 * the fallback tick. Renders nothing.
 */
export const ChannelUnreadSync = ({ spaceIds }: { spaceIds: string[] }) => {
  const { isAuthenticated } = useAuth()
  const { community } = useCommunity()
  const communityId = community?.id ?? null
  const key = [...spaceIds].sort().join(',')
  const enabled = isAuthenticated && Boolean(communityId) && spaceIds.length > 0

  React.useEffect(() => {
    clearChannelUnread()
    if (enabled) void refreshChannelUnread()
  }, [enabled, communityId, key])

  useRealtime(spaceIds.map((id) => `space:${id}`), () => { void refreshChannelUnread() }, { enabled, topics: TOPICS })
  return null
}
